import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge, validators } from 'tailwind-merge';

const mergeTailwindClasses = extendTailwindMerge({
  extend: {
    theme: {
      radius: [validators.isAnyNonArbitrary],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return mergeTailwindClasses(clsx(inputs));
}
